import { render, staticRenderFns } from "./CompanyLicenceComponent.vue?vue&type=template&id=646909d0&"
import script from "./CompanyLicenceComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyLicenceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports